import { routerReducer } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { APP_FEATURE_KEY, AppActionTypes, appReducer } from './index';
import { environment } from '@environments/environment';
import { AUTHENTICATION_FEATURE_KEY, authenticationReducer } from './reducers/authentication/authentication.reducer';
import { applicationReducer } from './reducers/application/application.reducer';

export const reducers: ActionReducerMap<unknown> = {
  app: appReducer,
  router: routerReducer,
  application: applicationReducer,
  authentication: authenticationReducer
};

export function clearStateAfterLogout(reducer) {
  return function (state, action) {
    if (action.type === AppActionTypes.SetInitialState) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers = !environment.production
  ? [localStorageSyncReducer, clearStateAfterLogout]
  : [localStorageSyncReducer, clearStateAfterLogout];

export function localStorageSyncReducer(reducer: ActionReducer<unknown>): ActionReducer<unknown> {
  return localStorageSync({
    keys: [
      // featureFlags and isMasquerading are user-session-specific and must not persist
      // across sessions — stale values cause incorrect routing for subsequent users.
      {
        [APP_FEATURE_KEY]: [
          'pending',
          'currentListing',
          'deviceInfo',
          'languageId',
          'channel',
          'listing',
          'listings',
          'headerRoutes',
          'tempPremiumFlag',
          'signUpFormShown'
        ]
      },
      AUTHENTICATION_FEATURE_KEY
    ],
    rehydrate: true
  })(reducer);
}
